class ComponentIngredientModal extends Theme.Component {

  connectedCallback() {
    this.addEvent("ingredient:click", document, this.show);
    this.addEvent("keydown", document, this.onKeyDown);

    this.events();
  }

  onKeyDown() {
    if (event.key == "Escape") {
      this.hide();
    }
  }

  show(event) {
    this.previousActiveElement = document.activeElement;

    const content = event.detail.target.nextElementSibling.innerHTML;

    this.elements.content.innerHTML = content;
    this.classList.add("state--active");

    setTimeout(() => {
      this.elements.body.focus();
    }, 50);
  }

  hide() {
    this.classList.remove('state--active');

    setTimeout(() => {
      this.elements.content.innerHTML = "";
      this.previousActiveElement.focus();
    }, 200);
  }
}

customElements.define('component-ingredient-modal', ComponentIngredientModal);
